import { Link } from 'react-router-dom';

const HERO_IMAGE_URL =
  'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/tadfv73p_ChatGPT%20Image%20May%2014%2C%202026%2C%2001_42_13%20PM.png';

export const HomeHero = () => (
  <section
    className="relative min-h-[88vh] flex items-center bg-cover bg-no-repeat"
    style={{ backgroundImage: `url(${HERO_IMAGE_URL})`, backgroundPosition: 'right center' }}
    data-testid="hero-section"
  >
    {/* Cinematic vignette */}
    <div className="absolute inset-0 bg-black/35 pointer-events-none"></div>
    {/* Brand-tinted left gradient for headline contrast — stronger on left to keep embedded watermark subtle */}
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        background:
          'linear-gradient(105deg, rgba(8,28,30,0.92) 0%, rgba(8,28,30,0.78) 28%, rgba(8,28,30,0.45) 55%, rgba(0,0,0,0.15) 78%, rgba(0,0,0,0) 100%)'
      }}
    ></div>
    {/* Subtle bottom fade for transition into the next section */}
    <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[#FDFBF7]/90 to-transparent pointer-events-none"></div>

    <div className="relative max-w-7xl mx-auto px-6 sm:px-8 md:px-12 z-10 w-full py-20 sm:py-24">
      <div className="max-w-3xl">
        <span
          className="reveal-on-mount inline-block bg-[#d3b163]/95 text-white px-4 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-[0.22em] mb-6 shadow-lg"
          data-testid="hero-eyebrow"
        >
          Dorado · Puerto Rico
        </span>
        <h1
          className="reveal-on-mount text-4xl sm:text-5xl lg:text-[64px] leading-[1.05] font-bold tracking-tight text-white mb-6"
          style={{ textShadow: '0 2px 22px rgba(0,0,0,0.55)', animationDelay: '60ms' }}
        >
          Un espacio donde cada niño puede brillar
        </h1>
        <p
          className="reveal-on-mount text-base sm:text-lg lg:text-xl text-white/95 mb-10 leading-relaxed max-w-2xl"
          style={{ textShadow: '0 1px 12px rgba(0,0,0,0.55)', animationDelay: '160ms' }}
        >
          En Rise & Shine Learning Zone acompañamos a cada estudiante con atención personalizada, apoyo académico y un ambiente seguro donde pueden crecer con confianza.
        </p>
        <div
          className="reveal-on-mount flex flex-col sm:flex-row gap-4 sm:gap-5"
          style={{ animationDelay: '260ms' }}
        >
          <Link
            to="/informacion-admision"
            data-testid="cta-solicita-info-hero"
            className="group inline-flex items-center justify-center gap-2 bg-[#d3b163] hover:bg-[#b89548] text-white px-8 sm:px-10 py-4 sm:py-[18px] rounded-full font-semibold text-base transition-all active:scale-[0.97] shadow-[0_10px_30px_-8px_rgba(211,177,99,0.65)] hover:shadow-[0_14px_36px_-6px_rgba(211,177,99,0.85)] hover:-translate-y-0.5"
          >
            Solicita Información
            <span className="transition-transform group-hover:translate-x-1">→</span>
          </Link>
          <Link
            to="/contacto"
            data-testid="cta-contactanos"
            className="inline-flex items-center justify-center bg-white/95 backdrop-blur text-[#43b6b8] hover:text-[#359a9c] px-8 sm:px-10 py-4 sm:py-[18px] rounded-full font-semibold text-base hover:bg-white transition-all border border-white/40"
          >
            Contáctanos
          </Link>
        </div>
      </div>
    </div>
  </section>
);
